import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { PdfService } from '../../services/pdf.service';

@Component({
  selector: 'app-service-terms',
  templateUrl: './service-terms.component.html',
  styleUrls: ['./service-terms.component.scss'],
  providers: [PdfService]
})
export class ServiceTermsComponent implements OnInit, OnChanges {
  @Input() public pdfLanguage: string;
  @Output() private pdfLanguageChanged = new EventEmitter<string>();
  private isLocalLanguageChange: boolean;
  private pdfMap: Map<string, string>;

  @ViewChild('pdfContainer', { read: ElementRef, static: true }) container: ElementRef;

  constructor(private pdfService: PdfService, private renderer: Renderer2) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.pdfLanguage && !this.isLocalLanguageChange) {
      if (!this.pdfMap) {
        this.pdfService.getPdfUrl().subscribe(data => {
          this.pdfMap = data;
          this.setPdfElementByUrl(this.pdfMap.get(this.pdfLanguage));
        });
      } else {
        this.setPdfElementByUrl(this.pdfMap.get(this.pdfLanguage));
      }
    }
  }

  onLanguageClick(value: string): void {
    if (!this.pdfMap) {
      this.pdfService.getPdfUrl().subscribe(data => {
        this.pdfMap = data;
        this.setLanguage(this.pdfLanguage);
      });
    } else {
      this.setLanguage(value);
    }
  }

  private setPdfElementByUrl(url: string): void {
    this.removeAllChildren(this.container);

    const object = this.createObjectElement();
    object.data = url;

    const altLink = this.createLinkElement(url);

    this.renderer.appendChild(object, altLink);
    this.renderer.appendChild(this.container.nativeElement, object);
  }

  private createObjectElement(): HTMLObjectElement {
    const object = document.createElement('object');
    object.classList.add('inner_content_viewer');
    object.type = 'application/pdf';
    return object;
  }

  private removeAllChildren(element: ElementRef) {
    for (let child of element.nativeElement.children) {
      this.renderer.removeChild(element.nativeElement, child);
    }
  }

  private createLinkElement(url: string): HTMLAnchorElement {
    const altLink = document.createElement('a');
    altLink.href = url;
    altLink.text = this.pdfService.getPdfFileName(url);
    return altLink;
  }

  private setLanguage(language: string): void {
    this.setPdfElementByUrl(this.pdfMap.get(language));
    this.isLocalLanguageChange = true;
    this.pdfLanguageChanged.emit(language);
  }
}
